import get from 'lodash/get';
import last from 'lodash/last';

import { toBoolean } from 'pages/utils/sanitize';

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'sale' implicitly has an 'any' type.
function getTaxClasses(sale) {
  if (!get(sale, 'TaxClassTotals.Tax[0]')) return {};

  return {
    TaxClassTotals: {
      Tax: [
        {
          id: get(sale, 'TaxClassTotals.Tax[0].id'),
          rate: parseFloat(get(sale, 'TaxClassTotals.Tax[0].rate', 0)),
          amount: parseFloat(get(sale, 'TaxClassTotals.Tax[0].amount', 0)),
          taxname: get(sale, 'TaxClassTotals.Tax[0].taxname'),
          subtotal: parseFloat(get(sale, 'TaxClassTotals.Tax[0].subtotal', 0)),
          rate2: parseFloat(get(sale, 'TaxClassTotals.Tax[0].rate2', 0)),
          amount2: parseFloat(get(sale, 'TaxClassTotals.Tax[0].amount2', 0)),
          taxname2: get(sale, 'TaxClassTotals.Tax[0].taxname2'),
          subtotal2: parseFloat(get(sale, 'TaxClassTotals.Tax[0].subtotal2', 0)),
        },
      ],
    },
  };
}

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'saleLine' implicitly has an 'any' type.
function getSaleLineItem(saleLine) {
  if (!get(saleLine, 'Item')) return {};

  return {
    Item: {
      description: get(saleLine, 'Item.description', ''),
      ...(get(saleLine, 'Item.Note.note') ? { Note: { note: saleLine.Item.Note.note } } : {}),
    },
  };
}

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'saleLine' implicitly has an 'any' type.
function getDiscount(saleLine) {
  if (!get(saleLine, 'Discount')) return {};

  return {
    Discount: {
      name: get(saleLine, 'Discount.name', ''),
      discountAmount: (parseFloat(get(saleLine, 'Discount.discountAmount', 0)) || -0) * -1,
      discountPercent: parseFloat(get(saleLine, 'Discount.discountPercent', 0)),
    },
  };
}

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'saleLine' implicitly has an 'any' type.
function getNote(saleLine) {
  if (!get(saleLine, 'Note')) return {};

  return {
    Note: {
      note: get(saleLine, 'Note.note', ''),
    },
  };
}

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'saleLine' implicitly has an 'any' type.
function getPaymentBySaleLineId(saleLine, sale) {
  const id = get(saleLine, 'saleLineID', '');
  let salePayment = get(sale, 'SalePayments.SalePayment');
  if (!Array.isArray(salePayment)) salePayment = [salePayment];

  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'saleP' implicitly has an 'any' type.
  return salePayment.find(saleP => get(saleP, 'SaleAccounts.SaleAccount.saleLineID') === id);
}

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'saleLine' implicitly has an 'any' type.
function getSaleLine(saleLine, sale) {
  const linkedPayment = getPaymentBySaleLineId(saleLine, sale);
  return {
    workOrder: get(saleLine, 'SaleLineWorkOrder'),
    tax: toBoolean(get(saleLine, 'tax')),
    saleLineID: parseFloat(get(saleLine, 'saleLineID', 0)),
    unitPrice: linkedPayment
      ? Math.abs(parseFloat(linkedPayment.amount))
      : parseFloat(get(saleLine, 'unitPrice', 0)),
    normalUnitPrice: parseFloat(get(saleLine, 'normalUnitPrice')),
    displayableSubtotal: linkedPayment
      ? Math.abs(parseFloat(linkedPayment.amount))
      : parseFloat(get(saleLine, 'displayableSubtotal', 0)),
    calcLineDiscount: parseFloat(get(saleLine, 'calcLineDiscount', 0)) * -1,
    unitQuantity: parseFloat(get(saleLine, 'unitQuantity', 0)),
    ...getSaleLineItem(saleLine),
    ...getNote(saleLine),
    ...getDiscount(saleLine),
  };
}

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'result' implicitly has an 'any' type.
function groupWorkOrders(result, saleLine) {
  const workOrder = get(saleLine, 'workOrder');
  if (!workOrder) {
    result.push(saleLine);
    return result;
  }

  if (workOrder.workOrderType === 'parent') {
    result.push({ ...saleLine, items: [] });
    return result;
  }

  const parentIndex = result.findIndex(
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'line' implicitly has an 'any' type.
    line => line.workOrder && line.workOrder.workOrderId === workOrder.workOrderId
  );
  if (parentIndex > -1) {
    result[parentIndex].items.push(saleLine);
  }

  return result;
}

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'sale' implicitly has an 'any' type.
function getSaleLines(sale) {
  if (!get(sale, 'SaleLines')) return {};

  return {
    SaleLines: {
      SaleLine: get(sale, 'SaleLines.SaleLine', [])
        // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'saleLine' implicitly has an 'any' type.
        .map(saleLine => getSaleLine(saleLine, sale))
        .reduce(groupWorkOrders, []),
    },
  };
}

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'sale' implicitly has an 'any' type.
function getCustomer(sale) {
  if (!get(sale, 'Customer')) return {};

  return {
    Customer: {
      firstName: get(sale, 'Customer.firstName', ''),
      company: get(sale, 'Customer.company', ''),
    },
  };
}

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'sale' implicitly has an 'any' type.
function getPaymentType(sale) {
  let salePayment = get(sale, 'SalePayments.SalePayment');

  if (!salePayment) return '';
  if (!Array.isArray(salePayment)) salePayment = [salePayment];

  const payment = last(salePayment);
  return get(payment, 'PaymentType.type', '');
}

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'sale' implicitly has an 'any' type.
export const transformPayload = sale => ({
  saleID: get(sale, 'saleID', ''),
  ticketNumber: parseFloat(get(sale, 'ticketNumber', 0)),
  calcDiscount: (parseFloat(get(sale, 'calcDiscount', 0)) || -0) * -1,
  calcTotal: parseFloat(get(sale, 'totalDue', 0)),
  calcSubtotal: parseFloat(get(sale, 'displayableSubtotal', 0)),
  taxTotal: parseFloat(get(sale, 'taxTotal', 0)),
  completed: get(sale, 'completed', ''),
  archived: get(sale, 'archived', ''),
  voided: get(sale, 'voided', ''),
  createTime: get(sale, 'createTime', ''),
  updateTime: get(sale, 'updateTime', ''),
  quoteID: get(sale, 'quoteID', ''),
  ...getCustomer(sale),
  ...getSaleLines(sale),
  ...getTaxClasses(sale),
  paymentType: getPaymentType(sale),
  change: parseFloat(get(sale, 'change', 0.0).toFixed(2)),
  calcTips: sale.tipEnabled ? parseFloat(get(sale, 'calcTips', 0).toFixed(2)) : null,
});
